import React, { useState } from "react";

const ForgotPasswordForm = ({ onBack }) => {
    const [email, setEmail] = useState("");
    const [error, setError] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");
        setSuccessMessage("");

        try {
            const response = await fetch("https://api.nfcdesignstudio.com/API/v1/forgot-password",
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ email }),
                }
            );

            if (response.ok) {
                setSuccessMessage(
                    "Password reset instructions sent to your email."
                );
                localStorage.removeItem("token");
            } else {
                const data = await response.json();
                setError(
                    data.error || "Failed to send password reset email. Please try again."
                );
            }
        } catch (err) {
            console.error(err);
            setError("Failed to send password reset email. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <h3 style={{ textAlign: "center", marginBottom: 16 }}>Forgot Password</h3>
            <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                <input
                    type="email"
                    placeholder="Enter your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    style={{ padding: 12, borderRadius: 8, border: "1px solid #e5e7eb" }}
                />
                {error && <p style={{ color: "#dc2626", fontSize: 14 }}>{error}</p>}
                {successMessage && (
                    <p style={{ color: "#16a34a", fontSize: 14 }}>{successMessage}</p>
                )}
                <button
                    type="submit"
                    disabled={loading}
                    style={{
                        padding: 12,
                        background: "#6366f1",
                        color: "#fff",
                        border: "none",
                        borderRadius: 8,
                        fontWeight: 600,
                        cursor: "pointer",
                    }}
                >
                    {loading ? "Sending..." : "Send Reset Link"}
                </button>
            </form>
            <button
                onClick={onBack}
                style={{
                    marginTop: 12,
                    background: "none",
                    border: "none",
                    color: "#6366f1",
                    cursor: "pointer",
                }}
            >
                ← Back to Login
            </button>
        </div>
    );
};

export default ForgotPasswordForm;
